import React from 'react';

import Box from '../Box'

export default props => {
    return (
        <section className="container" data-tb-region={props.blockSettings.tb_region}>
            <Box {...props} id="b1" type="BCollectionTile" settings={props.settings.b1} preserveImageRatio={true} classes="" />
        </section>
    );
}